import * as Types from '../../../generated/types';

import gql from 'graphql-tag';
import * as Urql from '@/urql/urqlWrapper';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IApplicationDocumentsVerifyDocumentMutationVariables = Types.Exact<{
  input: Types.IVerifyDocumentInput;
}>;


export type IApplicationDocumentsVerifyDocumentMutation = { __typename?: 'Mutation', verifyDocument: { __typename?: 'VerifyDocumentResponse', errors?: Array<{ __typename?: 'DefaultError', message: string, stackTrace?: string | null }> | null } };


export const ApplicationDocumentsVerifyDocumentDocument = gql`
    mutation ApplicationDocumentsVerifyDocument($input: VerifyDocumentInput!) {
  verifyDocument(input: $input) {
    errors {
      message
      stackTrace
    }
  }
}
    `;

export function useApplicationDocumentsVerifyDocumentMutation() {
  return Urql.useMutation<IApplicationDocumentsVerifyDocumentMutation, IApplicationDocumentsVerifyDocumentMutationVariables>(ApplicationDocumentsVerifyDocumentDocument);
};